import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from '../../App';
import { trackConnection, trackPageNavigation } from '../../analytics';

axios.defaults.withCredentials = true;
export default () => {
  useEffect(() => {
    setTimeout(() => {
      trackConnection();
      trackPageNavigation('Layout');
    }, 0);
  }, []);

  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};
